import { QueryClientProvider } from "@tanstack/react-query";
import { type RegisteredRouter, RouterProvider } from "@tanstack/react-router";
import { queryClient } from "@/lib/query-client";
import { AuthProvider } from "@/providers/AuthProvider";
import type { FunctionComponent } from "./common/types/types";
import { AppSidebarProvider } from "./components/layout/main/AppSidebar/rail";
import { Maintenance } from "./components/Maintenance";
import { env } from "./env";

type AppProps = { router: RegisteredRouter };

const App = ({ router }: AppProps): FunctionComponent => {
  if (env.VITE_MAINTENANCE_MODE === "true") return <Maintenance />;
  return (
    <AuthProvider>
      <AppSidebarProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AppSidebarProvider>
    </AuthProvider>
  );
};

export default App;
